<div class="container-fluid px-0 h-100">
    <div class="h-100  d-flex  justify-content-between">
        <!-- card 1 -->
        <div class="flex-grow-1 px-3 container_content">
            <div class="row justify-content-center">
                <div class="m-w-520 py-md-5 col-12">
                    <!-- main page login starts  -->
                    <div class="row py-md-5 py-4 flex-wrap">
                      <div class="col-12 mb-md-4 d-inline" (click)="call_me()">
                          <button tabindex="-1" type="button"
                            class="d-flex align-items-center p-2 border border_50">
                            <img src="assets\img\svg\back_arrow.svg" class="me-2" style="height: 24px;">
                            <span class="f-c-p-1 d-inline-block me-2">
                              Back
                            </span>
                          </button>
                      </div>
                        <div class="col-12 mt-3">
                            <img src="assets/img/svg/logo_login.svg" alt="" srcset="">
                        </div>
                        <div class="col-12 mt-5">
                            <h1 class="h1 f-w-800">
                               {{'CREATE NEW' | titlecase}}<span style="color:var(--d-blue)"> {{'PASSWORD!' | titlecase}}</span>
                            </h1>
                        </div>

                        <form class="m-w-520 w-100 mt-5" [formGroup]="user"
                        (ngSubmit)="submitForm(user)">

                        <div class="col-12 form-group pe-md-0 ">
                            <div #passwordContainer [ngClass]="[user.controls.newPassword.touched && user.controls.newPassword.invalid  ? '  b-10 m-h-56 custom-form inputContainer' : ' b-10 m-h-56 custom-form']">
                              <input type="text" [value]="displayedValue" (input)="handleInput($event)" autocomplete="off" class="input_field px-3 pt-3" name="password" (focus)="showPasswordPolicyContainer()"
                                formControlName="newPassword" required maxlength="30" (keypress)="mainService.handleInputSpace($event)" (blur)="hidePasswordPolicyContainer()"/>
                                <label for="text" class="label-name">
                                  <span class="content-name f-c-p-3">
                                   New Password
                                  </span>
                                </label>
                                <button style="    position: absolute;top: 9\px;right: 10px;cursor: pointer;" type="button" mat-icon-button class="d-inline me-2" matSuffix (click)="showNewPassword = !showNewPassword"
                              [attr.aria-label]="'Hide password'" [attr.aria-pressed]="showNewPassword">
                              <mat-icon>{{showNewPassword ? 'visibility' : 'visibility_off'}}</mat-icon>
                            </button>
                              <div class="policy__main" *ngIf="passwordPolicyContainer">
                                <p style="font-weight: 600;font-size: 12px;line-height: 16px;color:#656B73;">Password must have at least:</p>
                                <div class="min_length policy__common"
                                  [ngClass]="{
                                               'validField': !user.controls.newPassword.errors?.minLength,
                                               'invalidField': user.controls.newPassword.touched && user.controls.newPassword.errors?.minLength }">
                                  <img src="assets/img/png/tick2.png" alt="correct" style="width: 15px;height: 15px;"
                                    *ngIf="!user.controls.newPassword.errors?.minLength" />
                                  <img src="assets/img/png/red_cross.png" alt="incorrect" style="width: 8px;height: 8px; margin-right: 3px;"
                                    *ngIf="user.controls.newPassword.touched && user.controls.newPassword.errors?.minLength" />
                                  <span>
                                    8 characters
                                  </span>
                                </div>
                                <div class="number policy__common"
                                  [ngClass]="{
                                             'validField': !user.controls.newPassword.errors?.number,
                                             'invalidField': user.controls.newPassword.touched && user.controls.newPassword.errors?.number }">
                                  <img src="assets/img/png/tick2.png" alt="correct" style="width: 15px;height: 15px;"
                                    *ngIf="!user.controls.newPassword.errors?.number" />
                                  <img src="assets/img/png/red_cross.png" alt="incorrect" style="width: 8px;height: 8px; margin-right: 3px;"
                                    *ngIf="user.controls.newPassword.touched && user.controls.newPassword.errors?.number" />
                                  <span>
                                    1 number (0-9)
                                  </span>
                                </div>
                                <div class="lowercase policy__common"
                                  [ngClass]="{
                                             'validField': !user.controls.newPassword.errors?.lowercase,
                                             'invalidField': user.controls.newPassword.touched && user.controls.newPassword.errors?.lowercase }">
                                  <img src="assets/img/png/tick2.png" alt="correct" style="width: 15px;height: 15px;"
                                    *ngIf="!user.controls.newPassword.errors?.lowercase" />
                                  <img src="assets/img/png/red_cross.png" alt="incorrect" style="width: 8px;height: 8px; margin-right: 3px;"
                                    *ngIf="user.controls.newPassword.touched && user.controls.newPassword.errors?.lowercase" />
                                  <span>
                                    1 lowercase letter (a-z)
                                  </span>
                                </div>
                                <div class="uppercase policy__common"
                                  [ngClass]="{
                                              'validField': !user.controls.newPassword.errors?.uppercase,
                                              'invalidField': user.controls.newPassword.touched && user.controls.newPassword.errors?.uppercase }">
                                  <img src="assets/img/png/tick2.png" alt="correct" style="width: 15px;height: 15px;"
                                    *ngIf="!user.controls.newPassword.errors?.uppercase" />
                                  <img src="assets/img/png/red_cross.png" alt="incorrect" style="width: 8px;height: 8px; margin-right: 3px;"
                                    *ngIf="user.controls.newPassword.touched && user.controls.newPassword.errors?.uppercase" />
                                  <span>
                                    1 uppercase letter (A-Z)
                                  </span>
                                </div>
                                <div class="specialchar policy__common"
                                  [ngClass]="{
                                                'validField': !user.controls.newPassword.errors?.specialChar,
                                                'invalidField': user.controls.newPassword.touched && user.controls.newPassword.errors?.specialChar}">
                                  <img src="assets/img/png/tick2.png" alt="success" style="width: 15px;height: 15px;"
                                    *ngIf="!user.controls.newPassword.errors?.specialChar" />
                                  <img src="assets/img/png/red_cross.png" alt="incorrect" style="width: 8px;height: 8px; margin-right: 2px;"
                                    *ngIf="user.controls.newPassword.touched && user.controls.newPassword.errors?.specialChar" />
                                  <span>
                                    1 special character (!&#64;#$%^&*)
                                  </span>
                                </div>
                              </div>
                            </div>

                          <p class="mat-error mb-0 ms-0 ps-0"
                            *ngIf="user.controls.newPassword.touched && user.controls.newPassword.invalid">
                            Please enter a valid password.
                          </p>
                        </div>



                        <div class="col-12 form-group pe-md-0 mb-3">
                            <div  [ngClass]="[(user.controls.confirmPassword.touched && user.controls.confirmPassword.invalid) || (user.errors && user.errors.noMatch && user.controls.confirmPassword.touched ) ? '  b-10 m-h-56 custom-form inputContainer' : ' b-10 m-h-56 custom-form']">
                              <input type="text" [value]="displayedValueConfirm" (input)="handleInputConfirm($event)" autocomplete="off" class="input_field px-3 pt-3" name="password"
                                formControlName="confirmPassword" required  maxlength="30"/>
                                <label for="text" class="label-name">
                                  <span class="content-name f-c-p-3">
                                   Confirm Password
                                  </span>
                                </label>
                                <button style="    position: absolute;top: 9\px;right: 10px;cursor: pointer;" type="button" mat-icon-button class="d-inline me-2" matSuffix (click)="showConfirmPassword = !showConfirmPassword"
                              [attr.aria-label]="'Hide password'" [attr.aria-pressed]="showConfirmPassword">
                              <mat-icon>{{showConfirmPassword ? 'visibility' : 'visibility_off'}}</mat-icon>
                            </button>
                            </div>

                          <p class="mat-error mb-0 ms-0 ps-0"
                            *ngIf="(user.controls.confirmPassword.touched && user.controls.confirmPassword.invalid && !user.controls.confirmPassword.dirty) || (user.errors && user.errors.noMatch && user.controls.confirmPassword.touched )">
                            {{ user.errors && user.errors.noMatch && user.value.confirmPassword.length > 0 ? "Passwords did not match." : 'Please enter a valid password.'}}
                          </p>
                          <!-- <p class="mat-error mb-0 ms-0 ps-0"
                            *ngIf="user.controls.confirmPassword.touched && user.controls.confirmPassword.invalid && user.controls.confirmPassword.dirty">
                            Please enter valid password (should be greater than 6 characters).
                          </p> -->
                        </div>



                            <div class="col-12 mt-4 form-group">
                                <button button-primary-auth type="submit"
                                    class="me-3 mt-2 mt-sm-0 px-5 col-12 " [disabled]="(user.invalid) || (user.errors && user.errors.noMatch)">Change Password</button>
                            </div>

                        </form>
                    </div>
                </div>
            </div>
        </div>
        <div class=" d-sm-none d-none d-sm-none d-md-block img_bg container_carousel flex-grow-1 m-w-40p">
            <app-carousel></app-carousel>
        </div>
    </div>
</div>
